import React, { useState,useEffect, useMemo } from "react";
import * as PR from "../../../prime-modules/index";
import { aboutIoT1, aboutIoT2, plusIcon, graphIcon, connectIcon, optimizeIcon, arrowTopRight, arrowBottomRight, arrowBottom, futureImg1, futureImg2, futureImg3, futureImg4, countries, networks, payments, visa, masterCard, stripe, googlePay, applePay } from "../../../assets/images";
import "./LandingPage.scss";
import { useTranslationContext } from "../../../context/TranslationContext";
import { Link } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import { getCountriesAPI, getsubscriptionPlans, globalConfig } from "../../../services/api";
import countriesList  from "../../../assets/data/countries.json"
import { formatCurrency } from "../../../utils/reuse";

const LandingPage = () => {
  const { landingPage, faq } = useTranslationContext()
  const [faqData, setFaqData] = useState(undefined);

  const [networksModal, setNetworksModal] = useState(false);
  const [countriesModal, setCountriesModal] = useState(false);
  const [selectLocation, setSelectLocation] = useState(null);
  const [subscriptionPlans, setSubscriptionPlans ] = useState([])
  const { mutate: getSubscriptionHandler } = useMutation(getsubscriptionPlans, {
    onSuccess: res => {
       const groupedPlans = {};

      res.forEach((plan) => {
        const dataKey = plan.dataAmountForDisplay;
        const durationKey = durationMap[plan.duration];
        if (!groupedPlans[dataKey]) {
          groupedPlans[dataKey] = {};
        }
        groupedPlans[dataKey][durationKey] = formatCurrency(plan?.priceCurrency, plan?.price);
      });

  const pricingPlans = Object.entries(groupedPlans).map(([dataAmount, prices]) => ({
    dataAmount,
    prices,
  }));
  setSubscriptionPlans(pricingPlans);
    },
    onError: err => {
      console.log(err);
    }
  })

  useEffect(() => {
    if (!faq) return;
      getFAQData(faq);

  }, [faq,]);

  const getFAQData = (faqsNew) => {
    const categoriesData = faqsNew?.categories ? JSON.parse(faqsNew.categories) : {};
    
    const filteredCategories = Object.fromEntries(
      Object.entries(categoriesData).filter(([key, value]) => value.status === 1 && key === "FAQNEW-007")
    );
  
    const filteredFaqData = Object.fromEntries(
      Object.keys(filteredCategories)
        .filter((key) => key.startsWith("FAQNEW"))
        .map((key) => [key, faqsNew[key] ? JSON.parse(faqsNew[key]) : {}])
    );
    setFaqData(filteredFaqData);
  };

  const supportedDetails = [
    {
      img: countries,
      title: landingPage?.LNPL0039 || "Supported Countries",
      count: 23,
      onClick: () => setCountriesModal(true)
    },
   /*  {
      img: networks,
      title: landingPage?.LNPL0040 || "Supported Networks",
      count: 2,
      onClick: () => setNetworksModal(true)
    } */
  ];

  const pricingData = {
    plans: ["5GB", "10GB"],
    supportedCountries: [
        "Austria",
        "Belgium",
        "Bulgaria",
        "Czech Republic",
        "Denmark",
        "Finland",
        "France",
        "Germany",
        "Greece",
        "Hungary",
        "Ireland",
        "Italy",
        "Luxembourg",
        "Malta",
        "Netherlands",
        "Norway",
        "Poland",
        "Portugal",
        "Romania",
        "Spain",
        "Sweden",
        "Switzerland",
        "United Kingdom"
    ],
    supportedNetworks: [
      "Wind Hellas Telecommunications S.A. (2G/3G/4G/5G)",
      "Cable&Wireless Grenada Limited (2G/3G/4G/5G)"
    ]
  };
  
  const paymentMethods = [visa, masterCard, stripe, googlePay, applePay];

  const { data: locationsData } = useQuery(['CountriesAPI'], getCountriesAPI, {
    staleTime: 300000,
  });

 const matchedCountries = useMemo(() => {
  return countriesList
    .filter(country =>
      locationsData?.data?.some(iso => iso.toLowerCase() === country.iso.toLowerCase())
    )
    ?.map(country => ({
      ...country,
      iso: country.iso.toLowerCase()
    }))
    ?.sort((a, b) => a.name.localeCompare(b.name));
}, [locationsData]);

  useEffect(() => {
    if (matchedCountries.length > 0 && !selectLocation) {
      getSubscriptionHandler(matchedCountries[0]?.iso);
      setSelectLocation(matchedCountries[0]);
    }
  }, [getSubscriptionHandler, matchedCountries, selectLocation]);

  const durationMap = {
    1: 'Monthly Bundle',
    3: 'Quarterly Bundle',
    12: 'Annual Bundle',
  };

  const headers = ['Monthly Bundle', 'Quarterly Bundle', 'Annual Bundle'];

  return (
    <main className="landing-wrapper">
      {/* Info section */}
      <section className="iot-info-section">
        <div className="grid align-items-center">
          <div className="col-12 md:col-6 text-center">
            <PR.Image src={aboutIoT1} alt="Manage Your Plan with Ease" className="about-img" />
          </div>
          <div className="col-12 md:col-6">
            <h2>{landingPage?.LNPL0001 || "Manage Your Plan with Ease"}</h2>
            <p>{landingPage?.LNPL0002 || "Activate your SIM, track data usage, and change your subscription anytime.Our simple dashboard makes it easy to stay connected - no tech skills needed."}</p>
          </div>
        </div>
        <div className="grid align-items-center custom-mt">
          <div className="col-12 md:col-6 order-change">
            <h2>{landingPage?.LNPL0003 || "Flexible & Secure Payment Options"}</h2>
            <p>{landingPage?.LNPL0004 || "Pay your way - we support Visa, Mastercard, Google Pay, and Apple Pay. Choose a plan that fits your needs and upgrade anytime. No hidden fees, no surprises."}</p>
          </div>
          <div className="col-12 md:col-6 text-center">
            <PR.Image src={aboutIoT2} alt="Flexible & Secure Payment Options" className="about-img" />
          </div>
        </div>
      </section>

      {/* Getting started section */}
      <section className="get-started-section">
        <div className="grid align-items-center">
          <div className="col-12 md:col-2">
            <h2><span>{landingPage?.LNPL0005 || "Getting"}</span><span>{landingPage?.LNPL0005-1 || "started"}</span></h2>
          </div>
          <div className="col-12 md:col-10">
            <div className="grid align-items-center">
              <div className="col-12 md:col-3">
                <PR.Image src={plusIcon} alt="Sign Up" className="image-styling" />
                <h3>{landingPage?.LNPL0006 || "Sign Up"}</h3>
                <p>{landingPage?.LNPL0007 || "Setup your account and choose a subscription that fits your needs."}</p>
              </div>
              <div className="col-12 md:col-3 text-center">
                <PR.Image src={arrowTopRight} alt="Arrow Right" className="arrow-img" />
                <PR.Image src={arrowBottom} alt="Arrow Right" className="arrow-img show-on-mobile" />
              </div>
              <div className="col-12 md:col-3">
                <PR.Image src={graphIcon} alt="Monitor & Manage in Real-Time" className="image-styling" />
                <h3>{landingPage?.LNPL0008 || "Monitor & Manage in Real-Time"}</h3>
                <p>{landingPage?.LNPL0009 || "Use our intuitive dashboard for live tracking and analytics."}</p>
              </div>
            </div>
            <div className="grid mt-6 align-items-center">
              <div className="col-12 md:col-3 text-center">
                <PR.Image src={arrowBottomRight} alt="Arrow Bottom" className="arrow-img" />
                <PR.Image src={arrowBottom} alt="Arrow Right" className="arrow-img show-on-mobile" />
              </div>
              <div className="col-12 md:col-3">
                <PR.Image src={connectIcon} alt="Insert Your SIM" className="image-styling" />
                <h3>{landingPage?.LNPL0010 || "Insert Your SIM"}</h3>
                <p>{landingPage?.LNPL0011 || "Insert the SIM into your device to get connected."}</p>
              </div>
              <div className="col-12 md:col-3 text-center">
                <PR.Image src={arrowBottomRight} alt="Arrow Bottom" className="arrow-img" />
                <PR.Image src={arrowBottom} alt="Arrow Right" className="arrow-img show-on-mobile" />
              </div>
              <div className="col-12 md:col-3">
                <PR.Image src={optimizeIcon} alt="Optimize & Scale" className="image-styling" />
                <h3>{landingPage?.LNPL0012 || "Optimize & Scale"}</h3>
                <p>{landingPage?.LNPL0013 || "Adjust subscriptions dynamically as per your data needs."}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing plans section */}
      <section className="pricing-plans-section">
        <div className="pricing-box">
          <h2>{landingPage?.LNPL0034 || "Tailored Pricing plans"}</h2>
          <div className="location-dropdown-wrapper">
              
            <div className="grid align-items-center">
              <div className="col-12 md:col-8 text-left">
                <h5>{landingPage?.LNPL0052 || "Select your location to see pricing"}</h5>
              </div>
              <div className="col-12 md:col-4 ">
                <PR.Dropdown value={selectLocation} onChange={(e) => {
                  setSelectLocation(e.value);
                  getSubscriptionHandler(e.value.iso);
                  }} options={matchedCountries}
                  optionLabel="name" placeholder={landingPage?.LNPL0053 || "Select a location"} panelClassName="location-dropdown" 
                  />
              </div>
            </div>
             
          </div>
          <div className="flex w-full align-items-end gap-8">
            <div className="gb-div">
              {subscriptionPlans.map((item, index) => (
                <h4 key={index}>
                  {item.dataAmount}/month
                </h4>
              ))}
            </div>
            <div className="flex flex-1 align-items-center justify-content-between custom-margin m-flex">
              {headers.map((header, index) => (
                <div key={index} className="text-center">
                  <h4 className="under-line">
                    {header}
                  </h4>
                  {subscriptionPlans.map((item, idx) => (
                    <h3 key={idx}>
                      <span className="gb-pricing-plans">{item.dataAmount}: </span> {item.prices[header] || '-'}
                    </h3>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <div className="grid mt-8 justify-content-center">
            {supportedDetails.map((item, idx) => (
              <div className="col-12 md:col-4 text-center" key={idx}>
                <PR.Image src={item.img} alt={item.title} className="country-network-img" />
                <h4 className="mt-3">{item.title}</h4>
                <h2>{item.count}</h2>
                <Link className="view-details" onClick={item.onClick}>
                  {landingPage?.LNPL0041 || "View details "}
                </Link>
              </div>
            ))}
            <div className="col-12 md:col-4 text-center">
              <PR.Image src={payments} alt="Payment Methods" className="country-network-img" />
              <h4 className="mt-3">{landingPage?.LNPL0042 || "Payment Methods"}</h4>
              <div className="payment-methods">
                {paymentMethods.map((method, idx) => (
                  <PR.Image key={idx} src={method} alt={`Payment ${idx}`} className="payments-img" />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ's section */}
      <section className="faqs-block">
        <div className="grid mt-8">
          <div className="col-12 md:col-5">
            <h2>{landingPage?.LNPL0043 || "Frequently Asked Questions "}</h2>
          </div>
          <div className="col-12 md:col-7">
            <PR.Accordion activeIndex={0}>
              {!!faqData && Object.values(faqData).flat().map((item,index)=>{
                return(
                <PR.AccordionTab header={item?.question} key={index}>
                <div dangerouslySetInnerHTML={{ __html: item?.answer }} />
              </PR.AccordionTab>
              )})}
            </PR.Accordion>
          </div>
        </div>
      </section>

      {/* Features section */}
      <section className="features-section">
        <div className="grid align-items-center text-center">
          <div className="col-12 md:col-3">
            <PR.Image src={futureImg1} alt="Arrow Bottom" className="feature-img" />
            <div className="feature-info">
              <h2>{landingPage?.LNPL0014 || "Hassle-Free IoT SIM"} <br /> {landingPage?.LNPL0015 || "Management"}</h2>
              <p>{landingPage?.LNPL0016 || "One IoT connectivity platform for all your "} <br /> {landingPage?.LNPL0017 || "devices."}</p>
            </div>
          </div>
          <div className="col-12 md:col-3">
            <PR.Image src={futureImg2} alt="Arrow Bottom" className="feature-img" />
            <div className="feature-info">
              <h2>{landingPage?.LNPL0018 || "Cost-Effective"} <br /> {landingPage?.LNPL0019 || "Data Plans"}</h2>
              <p>{landingPage?.LNPL0020 || "Transparent"} <br /> {landingPage?.LNPL0021 || "pricing with no"} <br /> {landingPage?.LNPL0022 || "hidden fees"}</p>
            </div>
          </div>
          <div className="col-12 md:col-3">
            <PR.Image src={futureImg3} alt="Arrow Bottom" className="feature-img" />
            <div className="feature-info">
              <h2>{landingPage?.LNPL0023 || "24/7 IoT"} <br /> {landingPage?.LNPL0024 || "Support"}</h2>
              <p>{landingPage?.LNPL0025 || "Dedicated experts ensure smooth operations and minimal downtime."}</p>
            </div>
          </div>
          <div className="col-12 md:col-3">
            <PR.Image src={futureImg4} alt="Arrow Bottom" className="feature-img" />
            <div className="feature-info">
              <h2>{landingPage?.LNPL0026 || "Future-Ready IoT"} <br /> {landingPage?.LNPL0027 || "Solutions"}</h2>
              <p>{landingPage?.LNPL0028 || "Constantly evolving to meet industry-leading IoT standards."}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Partner section */}
      <section className="partner-section">
        <div className="partner-wrapper">
          <h2>{landingPage?.LNPL0029 || "Let's connect"} <br /> {landingPage?.LNPL0030 || "the future, together."}</h2>
          <div className="partner-box">
            <h3>{landingPage?.LNPL0031 || "Get started with data2go IoT today!"}</h3>
            <p>{landingPage?.LNPL0032 || "Sign up for a free IoT connectivity demo or contact our team to discover how data2go IoT can revolutionise your product offering."}</p>
            <PR.Button label={landingPage?.LNPL0033 || "Sign up now"} icon="pi pi-arrow-circle-right" iconPos="right" className="partner-button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} />
          </div>
        </div>
      </section>

       {/* Roaming Countries Dialog */}
      <PR.Dialog header={landingPage?.LNPL0039 || "Supported Countries"} visible={countriesModal} onHide={() => setCountriesModal?.(false)} className="landing-dialog countries-dialog" draggable={false} blockScroll>
        <div className="line"></div>
        <div className="content">
          <ul className="three-columns">
            {pricingData?.supportedCountries.map((item,index)=><li key={index}>{item}</li>)  }
          </ul>
        </div>
      </PR.Dialog>

      {/* Supported Networks Dialog */}
      <PR.Dialog header={landingPage?.LNPL0040 || "Supported Networks"} visible={networksModal} onHide={() => setNetworksModal?.(false)} className="landing-dialog" draggable={false} blockScroll>
        <div className="line"></div>
        <div className="content">
          <ul>
            {pricingData?.supportedNetworks.map((item,index)=><li key={index}>{item}</li>)}
          </ul>
        </div>
      </PR.Dialog>
    </main>

  );
};

export default LandingPage; 